import { render, staticRenderFns } from "./MonthlyChargesStore.vue?vue&type=template&id=c2ffdf00&"
import script from "./MonthlyChargesStore.vue?vue&type=script&lang=js&"
export * from "./MonthlyChargesStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports